export default "__VITE_ASSET__BbcvdBSk__"